var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndicators(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 11,
    viewBox: "0 0 48 11",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 10.6187,
    y: 2.3855,
    width: 2.2816,
    height: 7.49667,
    rx: 0.651885,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35913 4.66702C7.35913 4.307 7.65099 4.01514 8.01102 4.01514H8.98884C9.34887 4.01514 9.64073 4.307 9.64073 4.66702V9.23021C9.64073 9.59024 9.34887 9.8821 8.98884 9.8821H8.01102C7.65099 9.8821 7.35913 9.59024 7.35913 9.23021V4.66702Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09985 6.29678C4.09985 5.93676 4.39171 5.6449 4.75174 5.6449H5.72957C6.08959 5.6449 6.38145 5.93676 6.38145 6.29678V9.23026C6.38145 9.59029 6.08959 9.88215 5.72957 9.88215H4.75174C4.39171 9.88215 4.09985 9.59029 4.09985 9.23026V6.29678Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.840332 7.60049C0.840332 7.24047 1.13219 6.94861 1.49222 6.94861H2.47004C2.83007 6.94861 3.12193 7.24047 3.12193 7.60049V9.2302C3.12193 9.59023 2.83007 9.88209 2.47004 9.88209H1.49222C1.13219 9.88209 0.840332 9.59023 0.840332 9.23021V7.60049Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8907 8.4408C22.9328 8.39936 22.9561 8.34235 22.9549 8.28321C22.9537 8.22407 22.9281 8.16805 22.8843 8.12837C22.0131 7.3908 20.7373 7.3908 19.8661 8.12837C19.8223 8.16801 19.7967 8.22402 19.7955 8.28316C19.7942 8.3423 19.8174 8.39933 19.8595 8.4408L21.2238 9.81879C21.2638 9.85929 21.3183 9.88208 21.3752 9.88208C21.4321 9.88208 21.4866 9.85929 21.5266 9.81879L22.8907 8.4408Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 6.53736C22.2065 6.5373 23.0083 6.84667 23.6246 7.40535C23.708 7.48464 23.8393 7.48292 23.9206 7.40148L24.7091 6.6039C24.7507 6.56206 24.7737 6.50531 24.7731 6.44633C24.7725 6.38736 24.7483 6.33109 24.7059 6.29011C22.8291 4.54246 19.9225 4.54246 18.0457 6.29011C18.0033 6.33109 17.9791 6.38739 17.9785 6.44638C17.978 6.50537 18.0011 6.56212 18.0427 6.6039L18.831 7.40148C18.9123 7.48292 19.0436 7.48464 19.127 7.40535C19.7429 6.84704 20.5441 6.5377 21.375 6.53736Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.375 3.94237C22.8884 3.94244 24.3438 4.52452 25.4406 5.5683C25.5232 5.64888 25.6552 5.64787 25.7365 5.56602L26.526 4.76844C26.5672 4.72693 26.5902 4.6707 26.5898 4.61219C26.5895 4.55368 26.5659 4.49773 26.5242 4.4567C23.6455 1.6951 19.1041 1.6951 16.2254 4.4567C16.1837 4.49769 16.1601 4.55364 16.1597 4.61214C16.1593 4.67065 16.1822 4.7269 16.2234 4.76844L17.0131 5.56602C17.0944 5.64799 17.2265 5.64901 17.309 5.5683C18.4059 4.52445 19.8616 3.94237 21.375 3.94237Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5012 4.17814C30.5012 3.7281 30.866 3.36328 31.3161 3.36328H31.805V8.9043H31.3161C30.866 8.9043 30.5012 8.53948 30.5012 8.08945V4.17814Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8049 3.36328H33.1087V8.9043H31.8049V3.36328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1086 3.36328H34.4124V8.9043H33.1086V3.36328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4124 3.36328H35.7161V8.9043H34.4124V3.36328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7163 3.36328H37.0201V8.9043H35.7163V3.36328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.02 3.36328H38.3238V8.9043H37.02V3.36328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3237 3.36328H39.6275V8.9043H38.3237V3.36328Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9315 4.17814C40.9315 3.7281 40.5666 3.36328 40.1166 3.36328H39.6277V8.9043H40.1166C40.5666 8.9043 40.9315 8.53948 40.9315 8.08945V4.17814Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1973 4.0151C29.1973 2.93502 30.0728 2.05945 31.1529 2.05945H42.8868C43.9669 2.05945 44.8425 2.93502 44.8425 4.0151V8.25235C44.8425 9.33243 43.9669 10.208 42.8868 10.208H31.1529C30.0728 10.208 29.1973 9.33243 29.1973 8.25235V4.0151ZM31.1529 2.71133C30.4329 2.71133 29.8492 3.29505 29.8492 4.0151V8.25235C29.8492 8.97241 30.4329 9.55612 31.1529 9.55612H42.8868C43.6069 9.55612 44.1906 8.97241 44.1906 8.25235V4.0151C44.1906 3.29505 43.6069 2.71133 42.8868 2.71133H31.1529Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4944 7.62783C46.07 7.37634 46.4722 6.802 46.4722 6.13372C46.4722 5.46543 46.07 4.8911 45.4944 4.63961V7.62783Z",
    fill: "currentColor"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.9357,
    height: 10.4302,
    fill: "currentColor",
    transform: "translate(0.514404 0.42981)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0377,
    height: 10.4302,
    fill: "currentColor",
    transform: "translate(0.514404 0.42981)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4302,
    height: 10.4302,
    fill: "currentColor",
    transform: "translate(16.1597 0.42981)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2528,
    height: 10.4302,
    fill: "currentColor",
    transform: "translate(29.1973 0.42981)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.4302,
    height: 5.54102,
    fill: "currentColor",
    transform: "translate(30.5012 3.36328)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicators);
export default __webpack_public_path__ + "static/media/indicators.e2c0a274.svg";
export { ForwardRef as ReactComponent };